// Naval Battleship: Fleet Strike Client
import { sounds } from '../sound.js';

export class BattleshipGameClient {
  constructor(socket, containerEl) {
    this.socket = socket;
    this.container = containerEl;
    this.myGrid = Array(10).fill(null).map(() => Array(10).fill(0));
    this.enemyRadar = Array(10).fill(null).map(() => Array(10).fill(0));
    this.currentTurnId = null;
    this.players = [];

    this.render();
    this.setupSocketEvents();
  }

  render() {
    this.container.innerHTML = `
      <div class="bs-wrapper">
        <div class="bs-header">
          <div class="bs-meta">
            <h2>🚢 NAVAL BATTLESHIP: FLEET STRIKE</h2>
            <span class="bs-sub">Click on Enemy Radar to launch missile strikes • Sink all 5 enemy warships!</span>
          </div>
          <div id="bs-turn-badge" class="bs-badge">Waiting...</div>
        </div>

        <div class="bs-grids-container">
          <!-- My Fleet Grid -->
          <div class="bs-grid-box">
            <h3>🛡️ YOUR FLEET DEFENSE</h3>
            <div class="naval-grid" id="bs-my-grid"></div>
          </div>

          <!-- Enemy Radar Grid -->
          <div class="bs-grid-box">
            <h3>🎯 ENEMY RADAR (CLICK TO STRIKE)</h3>
            <div class="naval-grid" id="bs-enemy-grid"></div>
          </div>
        </div>
      </div>
    `;

    this.renderGrids();
  }

  renderGrids() {
    const myGridEl = document.getElementById('bs-my-grid');
    const enemyGridEl = document.getElementById('bs-enemy-grid');
    if (!myGridEl || !enemyGridEl) return;

    myGridEl.innerHTML = '';
    enemyGridEl.innerHTML = '';

    for (let r = 0; r < 10; r++) {
      for (let c = 0; c < 10; c++) {
        // My Grid Cell
        const myCell = document.createElement('div');
        const myVal = this.myGrid[r][c];
        myCell.className = `naval-cell ${myVal === 1 ? 'ship' : ''} ${myVal === 2 ? 'hit' : ''} ${myVal === 3 ? 'miss' : ''}`;
        myCell.innerText = myVal === 2 ? '💥' : (myVal === 3 ? '💧' : (myVal === 1 ? '🚢' : ''));
        myGridEl.appendChild(myCell);

        // Enemy Radar Cell
        const enemyCell = document.createElement('div');
        const enemyVal = this.enemyRadar[r][c];
        enemyCell.className = `naval-cell clickable ${enemyVal === 2 ? 'hit' : ''} ${enemyVal === 3 ? 'miss' : ''}`;
        enemyCell.innerText = enemyVal === 2 ? '💥' : (enemyVal === 3 ? '💧' : '');

        enemyCell.addEventListener('click', () => {
          const isMyTurn = String(this.currentTurnId).toLowerCase() === String(this.socket.id).toLowerCase();
          if (isMyTurn && enemyVal === 0) {
            sounds.playPop();
            this.socket.emit('bs_strike', { row: r, col: c });
          }
        });

        enemyGridEl.appendChild(enemyCell);
      }
    }
  }

  setupSocketEvents() {
    this.socket.on('bs_started', (data) => {
      this.myGrid = data.myGrid;
      this.currentTurnId = data.currentTurnId;
      this.players = data.players;
      sounds.playChime();
      this.updateTurnUI();
      this.renderGrids();
    });

    this.socket.on('bs_strikeResult', (data) => {
      const isAttacker = String(data.attackerId).toLowerCase() === String(this.socket.id).toLowerCase();

      if (isAttacker) {
        // Attacker marks their Enemy Radar only!
        this.enemyRadar[data.row][data.col] = data.isHit ? 2 : 3;
        if (data.isHit) sounds.playExplosion();
        else sounds.playPop();
      } else {
        // Defender marks their own Fleet Defense only!
        this.myGrid[data.row][data.col] = data.isHit ? 2 : 3;
        if (data.isHit) sounds.playExplosion();
      }

      if (data.sunkShip) {
        this.showToast(`🚨 SUNK: ${data.sunkShip} has been destroyed!`);
      }

      this.renderGrids();
    });

    this.socket.on('bs_turnChange', (data) => {
      this.currentTurnId = data.currentTurnId;
      sounds.playTick();
      this.updateTurnUI();
    });

    this.socket.on('bs_gameOver', (data) => {
      sounds.playVictory();
      this.showToast(`🏆 FLEET ADMIRAL: ${data.winner?.name || 'Player'} sank the entire enemy fleet!`);
    });
  }

  updateTurnUI() {
    const badge = document.getElementById('bs-turn-badge');
    const isMe = String(this.currentTurnId).toLowerCase() === String(this.socket.id).toLowerCase();
    const curP = this.players.find(p => String(p.id).toLowerCase() === String(this.currentTurnId).toLowerCase());

    if (badge) {
      badge.innerText = isMe ? '👉 YOUR TURN TO FIRE MISSILE!' : `Radar: ${curP?.name || 'Enemy'} targeting...`;
      badge.style.color = isMe ? '#22c55e' : '#38bdf8';
    }
  }

  showToast(text) {
    let toast = document.getElementById('bs-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'bs-toast';
      toast.style.cssText = 'position: absolute; top: 16px; left: 50%; transform: translateX(-50%); background: rgba(15, 23, 42, 0.95); border: 2px solid #38bdf8; color: #fbbf24; padding: 10px 20px; border-radius: 10px; font-weight: 900; font-size: 1rem; z-index: 100; box-shadow: 0 0 20px rgba(56, 189, 248, 0.5); pointer-events: none; text-align: center;';
      this.container.appendChild(toast);
    }
    toast.innerText = text;
    toast.style.display = 'block';
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(() => {
      if (toast) toast.style.display = 'none';
    }, 3000);
  }

  destroy() {
    clearTimeout(this.toastTimer);
    this.socket.off('bs_started');
    this.socket.off('bs_strikeResult');
    this.socket.off('bs_turnChange');
    this.socket.off('bs_gameOver');
  }
}
